<template>
  <div id="app-maybe-pic">
    <!-- 一张照片 -->
    <a href="https://item.taobao.com/item.htm?id=606846162714" target="_blank" rel="noopener noreferrer">
      <img alt="pic" class="app-maybe-pic" style="cursor: pointer" src="https://img.blendermagic.cn/new/article/ads2.jpg"/>
    </a>
  </div>
</template>

<script>
export default {
  name: "MaybePic"
}
</script>

<style scoped>

#app-maybe-pic {
  cursor: pointer;
  width: 350px;
  height: 350px;
  margin-bottom: 15px;
}

.app-maybe-pic {
  cursor: pointer;
  width: 350px;
  height: 350px;
}

</style>